import { Button, DynamicForm } from '@src/components/ui';
import { EButtonIntents } from '@src/typings';
import { FaCheck } from 'react-icons/fa6';
import { supportSchema } from '@src/formSchemas/supportSchema';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import { useState } from 'react';
import { useCreateTicketMutation } from '@src/services/tickets/tickets.slice';
import { useCheckResponse } from '@src/hooks/useCheckResponse';

const Support = ({ onClose }: { onClose?: () => void }) => {
    const { t } = useTranslation();
    const [successSent, setSuccessSent] = useState(false);
    const { checkResponse } = useCheckResponse();
    const [createTicket, { isLoading }] = useCreateTicketMutation();
    const onSubmit = async (formData: FieldValues) => {
        try {
            const body = {
                subject: formData.category,
                message: formData.message,
                email: formData.email,
            };
            await createTicket(body).unwrap();
            setSuccessSent(true);
        } catch (error) {
            checkResponse(error, 'createTicket');
        }
    };
    return successSent ? (
        <div className="flex flex-col">
            <span>{t('pages.support.thankYou')}</span>
            <Button
                className="w-1/2 !h-11 mt-8 self-center"
                intent={EButtonIntents.LightLinear}
                htmlType="button"
                onClick={onClose}
            >
                {t('buttons.close')}
            </Button>
        </div>
    ) : (
        <DynamicForm
            isLoading={isLoading}
            formRows={supportSchema(t)}
            formKeyName="support-form"
            onHandleSubmit={onSubmit}
            containerClassNames="flex gap-6 flex-col [&_.ant-picker-range]:w-full [&_.ant-picker-range]:!h-10 [&_.ant-radio-wrapper]:w-24 [&_.ant-radio-wrapper:last-child]:w-32"
            formFooter={
                <div className="w-full flex justify-between text-center space-x-2 mt-6">
                    <Button
                        className="w-full !h-11"
                        intent={EButtonIntents.LightLinear}
                        htmlType="button"
                        onClick={onClose}
                    >
                        {t('buttons.cancel')}
                    </Button>
                    <Button
                        htmlType="submit"
                        className="w-full text-center justify-center !h-11 !bg-primary-main"
                        icon={<FaCheck className="w-4 h-4" />}
                    >
                        {t('buttons.submit')}
                    </Button>
                </div>
            }
        />
    );
};
export default Support;